"use strict";

(function () {
  'use strict';

  messageBox.$inject = ['$element', '$transclude'];
  /* @ngInject */

  function messageBox($element, $transclude) {}

  angular.module('message-box', []).component('messageBox', {
    bindings: {},
    controller: messageBox,
    transclude: {
      heading: '?heading',
      content: '?content'
    },
    template: '<div class="message-box">' + '<h3 class="message-box--heading" ng-transclude="heading"></h3>' + '<div class="message-box--content" ng-transclude="content"></div>' + '</div>'
  });
})();